<template>
    <div>
    <div v-if="pageLoading" style="min-height: 150px;">
      <a-spin tip="Your document is being processed, do not leave this page!" :spinning="pageLoading" />
    </div>
    <a-form :form="form" id="form" v-else>
      <template v-if="mode == 'Create' || (mode == 'Create' && type=='draft')">
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', { initialValue: initialData.catatan }]"
          />
        </a-form-item>
        <a-form-item
          :label="(item.actor ? item.actor :'')+' '+item.jenis"
          v-for="(item, index) in lisAppr"
          :key="index"
        >
          <template v-if="item.nama == '-'">
            <a-select
              v-decorator="[
                item.actor ? (item.actor.replace(/\s/g, '').toLowerCase()) : 'empty',
                {
                  rules: [{ required: true }],
                },
              ]"
            >
              <a-select-option
                v-for="item in approval"
                :key="item.value"
                :value="item.value"
                >{{ item.text }}</a-select-option
              >
            </a-select>
          </template>
          <a-input
            disabled
            v-else
            v-decorator="[
              item.actor ? item.actor.replace(/\s/g, '').toLowerCase() : 'empty',
              {
                rules: [{ required: false }],
                initialValue: item.nama,
                key: item.tlc,
              },
            ]"
          ></a-input>
        </a-form-item>
      </template>
      <template v-else>
        <a-form-item label="Note">
          <a-textarea
            placeholder="Write the note here ... "
            :rows="4"
            v-decorator="['catatan', { initialValue: initialData.catatan }]"
          />
        </a-form-item>
        <a-row
          class="group-flex"
          v-for="item in lisAppr"
          :key="item.tlc"
        >
          <a-col span="6">
            <label>{{ item.actor }} {{ item.jenis }}</label>
          </a-col>
          <a-col span="1">:</a-col>
          <a-col
            ><a-tag>{{ item.nama }}</a-tag></a-col
          >
        </a-row>
      </template>
    </a-form>
    <br/>
    <span v-if="getScreen"> Is Data Completed ? &nbsp; </span>
    <a-switch v-if="getScreen" v-model="checkCompleted" size="small"
        checked-children="Yes" un-checked-children="No" :disabled="
        dataList.length <= 1 && mode === 'Edit' && type === 'revised'
      "
      @change="handleCheckData"/>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";

export default {
  name: "Approval",
  props: ["mode","type","id","collectData","lisAppr","id_lkb_draft"],
  data() {
    return {
      form: this.$form.createForm(this),
      approval: [],
      pageLoading: false
    }
  },
  computed:{
    ...mapGetters([
      "getAuth",
      "getScreen",
      "getDefaultDateFormat",
      "getStandartFormatDate",
    ]),
    initialData: function () {
      if (this.collectData.information === undefined || this.collectData.information.length <= 0) {
        return {
          catatan: "",
        };
      } else {
        return {
          catatan: this.collectData.catatan,
        };
      }
    },
  },
  mounted(){
    // if (this.mode == "Create" || this.type == "draft") {
      this.pageLoading = true
      this.getComboApproval().then(async (res) => {
        this.approval = res.data.data;
        await Event.$emit("stepsBailoutReportForm", this.approval);
        this.pageLoading = false
      });
    // }
  },
  methods:{
    async getComboApproval() {
      return await axios({
        method: "get",
        url: this.$serviceUrl + "bailout_report/approval",
        params:{
          tlc: this.getAuth.username,
          id_lkb: this.id?this.id:this.id_lkb_draft,
          is_draft: (this.type=="revised" ? 0 : 1)
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      });
    },
    handleRef(){
      this.form.validateFields((err, values) => {
        if (err) {
          this.displayMessage("form-warning");
          return;
        }
        Event.$emit("stepsBailoutReportFormCatatan", { note: values.catatan });
      });
    }
  }
}
</script>